import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const elementSeoSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default elementSeoSettingsEntity
